/**
 * 考勤管理 API
 */
import http from './httpRequest.js'

/**
 * 获取考勤统计数据（按月）
 * @param {Object} params 查询参数
 * @param {String} params.yearMonth 年月 格式：2026-08
 * @param {String} params.departmentId 部门ID（可选）
 */
export function getCheckinStats(params) {
  return http({
    url: '/admin/checkin/stats',
    method: 'GET',
    params
  })
}

/**
 * 获取考勤记录列表
 * @param {Object} params 查询参数
 * @param {String} params.yearMonth 年月
 * @param {String} params.userId 用户ID（可选）
 * @param {String} params.departmentId 部门ID（可选）
 * @param {String} params.status 状态 NORMAL/LATE/EARLY/ABSENT/REMOTE（可选）
 * @param {Number} params.page 页码
 * @param {Number} params.pageSize 每页数量
 */
export function getCheckinRecordList(params) {
  return http({
    url: '/admin/checkin/record/list',
    method: 'GET',
    params
  })
}

/**
 * 获取考勤汇总数据（按员工）
 * @param {Object} params 查询参数
 * @param {String} params.yearMonth 年月
 * @param {String} params.departmentId 部门ID（可选）
 * @param {String} params.keyword 关键词搜索（姓名/工号）
 * @param {String} params.userRole 角色类型（可选）
 * @param {Number} params.page 页码
 * @param {Number} params.pageSize 每页数量
 */
export function getCheckinSummaryList(params) {
  return http({
    url: '/admin/checkin/summary/list',
    method: 'GET',
    params
  })
}

/**
 * 导出考勤记录
 * @param {Object} params 查询参数
 */
export function exportCheckinRecord(params) {
  return http({
    url: '/admin/checkin/export',
    method: 'GET',
    params,
    responseType: 'blob'
  })
}

/**
 * 获取请假申请列表（管理端）
 * @param {Object} params 查询参数
 * @param {String} params.status 状态 PENDING/APPROVED/REJECTED
 * @param {String} params.startDate 开始日期
 * @param {String} params.endDate 结束日期
 * @param {String} params.keyword 关键词搜索
 * @param {Number} params.page 页码
 * @param {Number} params.pageSize 每页数量
 */
export function getLeaveApplicationList(params) {
  return http({
    url: '/admin/leave/application/list',
    method: 'GET',
    params
  })
}

/**
 * 审批请假申请
 * @param {Object} data 审批数据
 * @param {Number} data.id 请假记录ID
 * @param {String} data.status 审批状态 APPROVED/REJECTED
 * @param {String} data.remark 审批备注
 */
export function approveLeave(data) {
  return http({
    url: '/admin/leave/approve',
    method: 'PUT',
    data
  })
}

/**
 * 获取补卡申请列表（管理端）
 * @param {Object} params 查询参数
 * @param {String} params.status 状态 PENDING/APPROVED/REJECTED
 * @param {String} params.startDate 开始日期
 * @param {String} params.endDate 结束日期
 * @param {String} params.keyword 关键词搜索
 * @param {Number} params.page 页码
 * @param {Number} params.pageSize 每页数量
 */
export function getMakeupApplicationList(params) {
  return http({
    url: '/admin/makeup/application/list',
    method: 'GET',
    params
  })
}

/**
 * 审批补卡申请
 * @param {Object} data 审批数据
 * @param {Number} data.id 补卡记录ID
 * @param {String} data.status 审批状态 APPROVED/REJECTED
 * @param {String} data.remark 审批备注
 */
export function approveMakeup(data) {
  return http({
    url: '/admin/makeup/approve',
    method: 'PUT',
    data
  })
}

/**
 * 获取员工列表（用于筛选）
 * @param {Object} params 查询参数
 * @param {String} params.departmentId 部门ID（可选）
 * @param {String} params.userRole 角色类型（可选）
 * @param {String} params.status 状态（可选）
 */
export function getEmployeeSelectList(params) {
  return http({
    url: '/admin/employee/select/list',
    method: 'GET',
    params
  })
}

/**
 * 获取考勤规则配置
 */
export function getCheckinConfig() {
  return http({
    url: '/admin/checkin/config',
    method: 'GET'
  })
}

/**
 * 更新考勤规则配置
 * @param {Object} data 配置数据
 */
export function updateCheckinConfig(data) {
  return http({
    url: '/admin/checkin/config',
    method: 'PUT',
    data
  })
}

/**
 * 获取考勤图表统计数据
 * @param {String} yearMonth 年月
 */
export function getCheckinChartData(yearMonth) {
  return http({
    url: '/admin/checkin/chart',
    method: 'GET',
    params: { yearMonth }
  })
}
